import React from 'react';

export const RandomTab = () => (
    <p className='random-container'>
        We will take you to a random puzzle.
    </p>
)
